import { html, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { DERElement } from '~/common/der-element';
import { styles as globalStyles } from '~/ui/scss/main.styles';
import { styles } from './selector.styles';

export class Selector extends DERElement {
    static override styles = [unsafeCSS(globalStyles), unsafeCSS(styles)];

    @property({ type: Boolean })
    disabled = false;

    @property({ type: Boolean })
    active = false;

    constructor() {
        super();
        this.attachShadow({
            mode: 'open',
            delegatesFocus: true,
        });
    }

    override emitEvent(name: string, detail: unknown): void {
        this.dispatchEvent(new CustomEvent(name, { detail, bubbles: true, composed: true }));
    }

    onSelectClick(event: Event): void {
        if (!this.active) {
            this.emitEvent('der.click', {
                event,
            });
        }
    }

    override render() {
        return html`<button
            class=${classMap({
                'c-selector': true,
                active: this.active,
            })}
            ?disabled=${this.disabled}
            @click=${this.onSelectClick}
        >
            <slot></slot>
        </button> `;
    }
}
